import PropTypes from 'prop-types';
import {
    Tabs,
    Tab,
    Typography,
    Box,
} from '@mui/material';

const TabsForDays = ({
    tabs,
    value,
    onChange,
}) => {

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 5 }}>
            <Tabs
                value={value}
                onChange={onChange}
                indicatorColor="transparent"
                variant={"scrollable"}
                scrollButtons={"auto"}
                sx={{
                    "& .MuiTabs-flexContainer": {
                        flexWrap: "nowrap",
                    },
                    flexGrow: 1,
                    overflowX: "auto",
                    borderBottom:"1px solid #CCCCCC"
                }}
            >
                {tabs.map((item, index) => (
                    <Tab
                        key={index}
                        sx={{
                            background: value === index ? "#DC143C" : 'primary.main',
                            border: '1px solid #DC143C',
                            padding: 0,
                            px:2,
                            mx: 1,
                            borderRadius: "5px",
                            minHeight: "35px"

                        }}
                        label={
                            <Typography
                                variant='body2'
                                sx={{
                                    color: value === index ? "primary.main" : '#DC143C',
                                    textTransform: "capitalize",
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {item.label}

                            </Typography>
                        }
                    />
                ))}
            </Tabs>
        </Box>
    );
};

TabsForDays.propTypes = {
    tabs: PropTypes.array.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,

};

export default TabsForDays;
